{
	"name": "@alexaegis/autotool-plugin-vitest",
	"description": "Setup vitest",
	"version": "0.15.6",
	"license": "MIT",
	"private": false,
	"archetype": {
		"platform": "node",
		"framework": "autotool",
		"language": "ts",
		"kind": "lib"
	},
	"keywords": [
		"autotool-plugin",
		"managed-by-autotool",
		"vitest"
	],
	"repository": {
		"url": "git+https://github.com/AlexAegis/js-tooling.git",
		"type": "git"
	},
	"type": "module",
	"publishConfig": {
		"access": "public",
		"exports": {
			".": {
				"types": "./dist/index.d.ts",
				"import": "./dist/index.js",
				"require": "./dist/index.cjs",
				"default": "./dist/index.js"
			},
			"./package-node-vitest.config": "./static/package-node-vitest.config.ts",
			"./package-svelte-vitest.config": "./static/package-svelte-vitest.config.ts",
			"./package-web-vitest.config": "./static/package-web-vitest.config.ts",
			"./package.json": "./package.json",
			"./readme": "./readme.md"
		}
	},
	"files": [
		"dist",
		"static"
	],
	"engines": {
		"node": ">=22.6.0"
	},
	"scripts": {
		"lint:depcheck": "turbo run lint:depcheck_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"lint:depcheck_": "depcheck",
		"lint:es": "turbo run lint:es_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"lint:es_": "eslint --max-warnings=0 --fix --no-error-on-unmatched-pattern .",
		"lint:format": "turbo run lint:format_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"lint:format_": "prettier --cache-location .cache/prettier --plugin prettier-plugin-svelte --plugin prettier-plugin-tailwindcss --check .",
		"lint:md": "turbo run lint:md_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"lint:md_": "remark --frail --no-stdout --silently-ignore .",
		"lint:tsc": "turbo run lint:tsc_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"lint:tsc_": "tsc --noEmit",
		"publint": "BUILD_REASON='publish' turbo run publint_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"publint_": "publint",
		"test": "turbo run test_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"test_": "vitest --passWithNoTests --coverage --run",
		"test:watch": "vitest --passWithNoTests --coverage",
		"all": "BUILD_REASON='publish' turbo run all_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"build": "turbo run build-lib_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"build-lib_": "vite build",
		"format": "turbo run format_ --concurrency 16 --filter @alexaegis/autotool-plugin-vitest",
		"format_": "prettier --cache-location .cache/prettier --plugin prettier-plugin-svelte --plugin prettier-plugin-tailwindcss --write ."
	},
	"exports": {
		".": {
			"types": "./src/index.ts",
			"import": "./dist/index.js",
			"require": "./dist/index.cjs",
			"default": "./dist/index.js"
		},
		"./package-node-vitest.config": "./static/package-node-vitest.config.ts",
		"./package-svelte-vitest.config": "./static/package-svelte-vitest.config.ts",
		"./package-web-vitest.config": "./static/package-web-vitest.config.ts",
		"./package.json": "./package.json",
		"./readme": "./readme.md"
	},
	"dependencies": {
		"@alexaegis/coverage-tools": "workspace:^",
		"@alexaegis/logging": "workspace:^",
		"@alexaegis/predicate": "workspace:^",
		"autotool-plugin": "^0.8.0"
	},
	"devDependencies": {
		"@alexaegis/eslint-config-vitest": "workspace:^",
		"@alexaegis/ts": "workspace:^",
		"@alexaegis/vite": "workspace:^",
		"@alexaegis/vitest": "workspace:^",
		"@lcov-viewer/cli": "^1.3.0",
		"@types/node": "^26.1.1",
		"@vitest/coverage-v8": "^4.1.10",
		"publint": "^0.3.21",
		"typescript": "^6.0.3",
		"vite": "^8.1.4",
		"vite-plugin-dts": "^5.0.3",
		"vitest": "^4.1.10"
	}
}
